/**
 * Service page tabs (r2c/service-details).
 *
 * The block prints every panel with the first one shown; clicking a tab
 * shows its panel and hides the others. Arrow keys move between tabs, as the
 * ARIA tabs pattern expects.
 */
document.querySelectorAll('.r2c-tabs').forEach(function (list) {
	const links = Array.from(list.querySelectorAll('.r2c-tabs__link'));

	function select(link) {
		links.forEach(function (other) {
			const active = other === link;
			const panel = document.getElementById(other.getAttribute('aria-controls'));

			other.setAttribute('aria-selected', String(active));
			other.setAttribute('tabindex', active ? '0' : '-1');
			other.parentElement.classList.toggle('is-active', active);

			if (panel) {
				panel.hidden = !active;
			}
		});
	}

	links.forEach(function (link, index) {
		link.addEventListener('click', function (event) {
			event.preventDefault();
			select(link);
		});

		link.addEventListener('keydown', function (event) {
			if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
				return;
			}

			event.preventDefault();

			const next = links[(index + (event.key === 'ArrowRight' ? 1 : links.length - 1)) % links.length];
			select(next);
			next.focus();
		});
	});
});
